import { ServerStatus } from './../Models/ApplicationInterfaces';

window.WebSocket = window.WebSocket || window.MozWebSocket;
// CHANGE LOCALHOST TO REGEX ON ##.##.##.##
const ogOrigin : string = window && window.origin ? window.origin : window.location.origin;
const protocol = window.location.protocol;
class NetworkManager {
    private connected:boolean = false;  
    public isConnected = () => this.connected;

    public async getLoginStatus():Promise<ServerStatus>  {
        let origin = ogOrigin.replace("https://",'');
        origin = origin.replace("http://",'');
        const originData = origin.split(":");
        if(originData[1] === "3000"){
            origin = originData[0]+":80"
        }
        return await fetch(`${protocol}//${origin}/serviceStatus`)
            .then(
                async res => {
                    return res.json();
                }
            ).catch(err=> null);
    }

    public async getServerString(code:string):Promise<{status:number, connectionString: string}>  {
        return await fetch(`/game?code=${code}`)
            .then(
                async res => {
                    if(res.status !== 200){
                        return {status:res.status, connectionString:""}
                    }
                    const body = await res.json();
                    const json = JSON.parse(body);
                    return {status: res.status, connectionString: json.connectionString || null}
                }
            ).catch(err=> ({status:err.status, connectionString:""}));
    }
    public async connectToServer(server:string, code:string, name:string, icon:number, color:string){ 
        console.log(server,window.origin)
        window.location.href = `${protocol}//${server}?code=${code}&name=${name}&icon=${icon}&color=${color}`;
    }
    
}  

export const networkManager = new NetworkManager();


// WEBPACK FOOTER //
// ./src/NetworkManager/NetworkManager.ts